<template>
	<div id="about">
		<div class="container">
			<div class="about-logo">
				<img src="@/images/corporate/about/logo.png" alt="logo" />
			</div>

			<i18n path="main.about-nexon.row-1" tag="p">
				<template v-slot:nexon>
					<strong>{{ $t('main.nexon') }}</strong>
				</template>
			</i18n>

			<i18n path="main.about-nexon.row-2" tag="p">
				<template v-slot:n-live-games>
					<strong>{{ $t('main.about-nexon.n-live-games', { n: 80 }) }}</strong>
				</template>
				<template v-slot:n-countries>
					<strong>{{ $t('main.about-nexon.n-countries', { n: 190 }) }}</strong>
				</template>
			</i18n>

			<i18n path="main.about-nexon.row-3" tag="p">
				<template v-slot:ip-franchise-hits>
					<i>{{ $t('main.about-nexon.ip-franchise-hits') }}</i>
				</template>
			</i18n>

			<p>{{ $t('main.about-nexon.row-4') }}</p>

			<p class="about-na">{{ $t('main.about-nexon.about-nexon-america') }}</p>

			<p>
				<strong>{{ $t('main.about-nexon.player-satisfaction') }}</strong>
			</p>

			<i18n path="main.about-nexon.description" tag="p">
				<template v-slot:nexon-america>
					<strong>{{ $t('main.about-nexon.nexon-america') }}</strong>
				</template>
			</i18n>

			<div class="about-badge"></div>

			<div class="links">
				<a v-if="showPressReleases" :href="pressReleasesURL">
					{{ $t('main.about-nexon.press-releases') }}
				</a>
				<a href="https://pressroom.nexon.com/corporate" target="_blank">
					{{ $t('main.about-nexon.press-kit') }}
				</a>
				<router-link :to="{ name: 'careers' }">
					{{ $t('main.about-nexon.careers') }}
				</router-link>
				<a href="https://ir.nexon.co.jp/en/" target="_blank">
					{{ $t('main.about-nexon.investor-relations') }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import pressReleasesURL from '@/config/press-releases-url';

export default {
	name: 'AboutNexon',
	data() {
		return {
			pressReleasesURL,
		};
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('main.press-releases.about-company')}`,
		};
	},
	computed: {
		showPressReleases() {
			return environment.region !== 'sea';
		},
	},
};
</script>

<style lang="less" scoped>
#about {
	background-repeat: no-repeat;
	background-image: radial-gradient(circle at top, #276a60, #1a3530, #15191a, #121212 35%);
	padding-top: 56px;
	padding-bottom: 100px;
	color: #adadad;

	.container {
		max-width: 1024px;
		width: 100%;
		margin: 0 auto;
		font-size: 12px;
		font-family: 'KlavikaNX Light';
		padding: 0;
	}
	.about-logo {
		margin-top: 100px;
		margin-bottom: 82px;
		text-align: center;
		img {
			width: 600px;
		}
	}

	p {
		font-size: 18px;
		margin-bottom: 20px;
		line-height: normal;
		strong {
			font-family: 'KlavikaNX Light';
			color: #fff;
		}
	}

	.about-na {
		font-size: 24px;
		text-transform: uppercase;
		color: #40d0ba;
		padding-top: 10px;
	}

	.about-badge {
		background-image: url('~@/images/corporate/badge-great-place-to-work.png');
		background-repeat: no-repeat;
		background-position-x: 50%;
		background-position-y: center;
		background-size: 100%;
		background-repeat: no-repeat;
		width: 123px;
		height: 200px;
		margin: 0 auto;
	}

	.links {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		flex: 0 1 auto;
		align-items: center;
		a {
			background-color: #fff;
			color: #212121;
			flex-basis: 40%;
			margin-top: 50px;
			padding: 10px 0;
			text-transform: uppercase;
			font-size: 24px;
			line-height: normal;
			text-align: center;
			border-radius: 40px;
			text-decoration: none;
			transition: 0.2s;
			&:hover {
				background-color: #40d0ba;
			}
		}
	}

	@media (max-width: 1024px) {
		background-image: radial-gradient(circle at top, #276a60, #172321, #121212 20%);
		padding-bottom: 50px;

		.container {
			max-width: 100%;
			padding-left: 20px;
			padding-right: 20px;
		}
		.about-logo {
			margin-top: 50px;
			margin-bottom: 62px;
			img {
				width: 100%;
			}
		}
		p {
			font-size: 15px;
		}
		.about-na {
			font-size: 18px;
			padding-top: 20px;
		}

		.links {
			justify-content: space-between;
			a {
				margin-top: 30px;
				flex-basis: 47%;
				max-width: 47%;
				padding: 10px 0;
				font-size: 16px;
				border-radius: 50px;
			}
		}
	}
	@media (max-width: 500px) {
		.links {
			a {
				margin-top: 10px;
				flex-basis: 100%;
				max-width: 100%;
			}
		}
	}
}
</style>
